<template>
  <ValidationProvider v-slot="{ errors }" :name="`'${label}'`" :rules="rules" :vid="vid">
    <organizations-prepayments
        v-model="innerValue"
        :error-messages="errors"
        :readonly="readonly"
        :label="label"
        :required-color="requiredColor"
        :required="required"
        :loading="loading" />
  </ValidationProvider>
</template>

<script>
  import OrganizationsPrepayments from './OrganizationsPrepayments.vue'

  export default {
    components: {
      OrganizationsPrepayments
    },
    props: {
      value: {
        type: Array,
        default: () => {
          return []
        }
      },
      rules: [String, Object],
      label: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      loading: {
        type: Boolean,
        default: false
      },
      vid: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        innerValue: null
      }
    },
    computed: {
      required () {
        if (!this.rules) {
          return false
        }
        return (this.rules.hasOwnProperty('required') && this.rules.required) ||
          (!this.rules.hasOwnProperty('required') && !!this.rules.length && this.rules.includes('required'))
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (newVal) {
          if (newVal !== this.innerValue) {
            this.innerValue = newVal?.map(x => ({ ...x }))
          }
        }
      },
      innerValue (val) {
        this.$emit('input', val)
      }
    }
  }
</script>
